import { useContext } from "react";

import { GlobalContext } from "./Global.context";

export function useGlobalState() {
  return useContext(GlobalContext);
}
